module.exports = __webpack_public_path__ + "static/media/main_btn.bba83ba7.svg";